module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("WJWZj"))).then(() => parcelRequire('1iHdE'));